
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/curso-scrum-developer-gye-abr2019",
      function () {
        return require("private-next-pages/clases/curso-scrum-developer-gye-abr2019.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clases/curso-scrum-developer-gye-abr2019"])
      });
    }
  